export default __webpack_public_path__ + "static/media/logo-movil.27cfb518.svg";